module.exports = __webpack_public_path__ + "img/regular_comm_fault_off.eb9474fa.svg";